import 'popper.js'
import 'bootstrap'
import 'katex'
const katex = require('katex');
require('typeface-montserrat')
require('typeface-courgette')
require('typeface-poppins')
require('typeface-noto-sans')
